import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import koCommon from '../locales/ko/common.json';
import enCommon from '../locales/en/common.json';
import koStudent from '../locales/ko/student.json';
import enStudent from '../locales/en/student.json';
import koObject from '../locales/ko/object.json';
import enObject from '../locales/en/object.json';
import koOper from '../locales/ko/operator.json';
import enOper from '../locales/en/operator.json';

const STORAGE_KEY = 'language';

export function getSavedLanguage(): 'ko' | 'en' {
	const v = localStorage.getItem(STORAGE_KEY);
	if (!v) {
		return 'ko';
	} else {
		return v === 'en' ? 'en' : 'ko';
	}
}

export function setSavedLanguage(lang: 'ko' | 'en') {
	localStorage.setItem(STORAGE_KEY, lang);
}

i18n.use(initReactI18next).init({
	resources: {
		ko: { common: koCommon, student: koStudent, object: koObject, oper: koOper },
		en: { common: enCommon, student: enStudent, object: enObject, oper: enOper },
	},

	lng: getSavedLanguage(),
	fallbackLng: 'ko',

	// ✅ 네임스페이스 목록
	ns: ['common', 'student', 'object', 'oper'],
	defaultNS: 'common',

	interpolation: { escapeValue: false },
	saveMissing: true,
	missingKeyHandler: (key, options) => {
		console.log('missing key', key, options);
		return key;
	},
});

export default i18n;
